import { useCallback } from 'react'
import styled from 'styled-components'

import { useRegionAdventuresQuery } from 'hooks/useQueries'

import Container from '../../../../components/layout/Container'
import SuggestedAdventures from '../../../adventure/SuggestedAdventures'

const Title = styled.h1`
  margin: 0;
  margin-bottom: 32px;
  font-size: 20px;
  line-height: 1.1;

  color: ${({ theme }) => theme.brand.forest};
`
type RegionAdventureProps = {
  regionId: string
}

const RegionAdventures = ({ regionId }: RegionAdventureProps) => {
  const { data, loading, fetchMore } = useRegionAdventuresQuery({
    variables: {
      regionId,
    },
  })

  const adventures = data?.region?.adventures

  const pageInfo = data?.region?.adventures?.pageInfo

  const endCursor = pageInfo?.endCursor
  const hasNextPage = pageInfo?.hasNextPage

  const noAdventures = !adventures || adventures?.edges?.length === 0

  const isEmpty = !loading && noAdventures

  const handleFetchMore = useCallback(() => {
    fetchMore({
      variables: {
        cursor: endCursor,
      },
    })
  }, [fetchMore, pageInfo])

  return (
    <Container>
      <SuggestedAdventures
        adventures={adventures}
        inItineraryContext={false}
        canFetchMore={hasNextPage}
        loading={loading}
        isEmpty={isEmpty}
        handleFetchMore={handleFetchMore}
        maxSlidesDesktop={4}
        customTitle={<Title>Things to do in this area</Title>}
      />
    </Container>
  )
}

export default RegionAdventures
